import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

import { ref, onMounted, computed, watch } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { summarizeTheInvoiceInformation } from '@V/invoice/src/data-source/apis';
import { formatter } from '@/utils';
import { useRouteMeta } from '@hooks/common';
import { MAIN_TABS, TABS } from '@V/invoice/src/constants';
import InvoiceFilingList from '@V/invoice/src/components/invoice-filing-list.vue';
import { RouteQuery, MainTabKey } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';
// import appStore from '@/store';
// import { storeToRefs } from 'pinia';
import { IS_PLATFORM_TYPE_1, IS_ASSISTANT } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-main',
  setup(__props) {

const route = useRoute();
const routeMeta = useRouteMeta();
// const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const routeQuery = route.query as RouteQuery;
const isAsp = [2].includes(+routeMeta.functionCode);
const isSupplier = [3].includes(+routeMeta.functionCode);
const isGy = [1].includes(+routeMeta.functionCode);

const mainTab = ref<MainTabKey>(1);
const subTab = ref(1);

const isFlat = computed(() => isSupplier || isGy);

const subTabs = computed(() => {
  if (isFlat.value) return [];
  const mt = MAIN_TABS[mainTab.value];
  if (!mt?.children) return [];
  return Object.values(mt.children);
});

const curCmopt = computed(() => {
  if (isSupplier) return TABS[mainTab.value]?.cmpt;
  if (isGy) return InvoiceFilingList;
  const mt = MAIN_TABS[mainTab.value];
  return mt?.children?.[subTab.value]?.cmpt;
});

const curCmoptProps = computed(() => {
  if (isFlat.value) return {};
  const mt = MAIN_TABS[mainTab.value];
  const child = mt?.children?.[subTab.value];
  return { invoiceTabType: (child as any)?.type };
});

const mainTabs = computed(() => {
  if (isAsp) {
    // 服务助手，不需要给自然人\个体开票
    if (IS_ASSISTANT) {
      return [MAIN_TABS[3], MAIN_TABS[4]];
    }
    // 向日葵平台可看见所有，但是在个体发票中只有运营基地有全部操作权限
    if (IS_PLATFORM_TYPE_1) {
      return Object.values(MAIN_TABS);
    }
    // 独立平台
    return [MAIN_TABS[2], MAIN_TABS[3], MAIN_TABS[4]];
  }
  if (isSupplier) return [TABS[1], TABS[2]];
  if (isGy) return [{ label: '开票记录', value: 1, cmpt: InvoiceFilingList }];
  return [];
});
const curKey = computed(() => `${mainTab.value}_${subTab.value}`);

watch(mainTab, () => {
  subTab.value = subTabs.value[0]?.value ?? 1;
});
watch(
  () => mainTabs.value,
  v => {
    if (v.length) {
      mainTab.value = +(routeQuery.mainTab || v[0]?.value || 1) as MainTabKey;
      subTab.value = +(routeQuery.subTab || 1);
    }
  },
  { immediate: true, deep: true }
);

const statisticsConfig = {
  amountToBeInvoiced: { label: '待开票金额', value: '' },
  amountToBeInvoicedNum: { label: '待开票订单笔数', value: '' },
  monthlyInvoicingAmountToBeProcessed: { label: '月度待开票金额', value: '' },
  inTheProcessOfInvoicing: { label: '开票中', value: '' },
  annualCumulativeAmount: { label: '当年累计开票金额', value: '' },
  annualCumulativeNum: { label: '当年累计开票数', value: '' },
  lastMonthAmount: { label: '上一个月度累计开票金额', value: '' },
  lastMonthNum: { label: '上一个月度累计开票笔数', value: '' },
  redInkInvoiceNum: { label: '红冲发票数', value: '' },
  redInkInvoiceAmount: { label: '红冲发票金额', value: '' }
} as const;

const statistics = ref<Record<string, { label: string; value: string }>>({});
onMounted(async () => {
  statistics.value = Object.fromEntries(
    Object.entries(statisticsConfig).map(([k, v]) => [k, { ...v }])
  ) as any;

  if (!isGy) {
    const { data } = await summarizeTheInvoiceInformation();
    Object.keys(statistics.value).forEach(key => {
      if (
        [
          'amountToBeInvoiced',
          'monthlyInvoicingAmountToBeProcessed',
          'annualCumulativeAmount',
          'lastMonthAmount',
          'redInkInvoiceAmount'
        ].includes(key)
      ) {
        statistics.value[key].value = formatter.fen2yuan(data[key]);
      } else {
        statistics.value[key].value = data[key];
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (mainTabs.value.length > 1)
      ? (_openBlock(), _createBlock(_unref(BaseTabs), {
          key: 0,
          style: {"margin":"10px 0"},
          modelValue: mainTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mainTab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainTabs.value, (item) => {
              return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                label: item.label,
                name: item.value,
                key: item.value
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (subTabs.value.length > 1)
      ? (_openBlock(), _createBlock(_unref(BaseTabs), {
          key: 1,
          style: {"margin":"0 0 10px 0"},
          modelValue: subTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subTab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTabs.value, (item) => {
              return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                label: item.label,
                name: item.value,
                key: item.value
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(curCmopt.value), _mergeProps({ key: curKey.value }, curCmoptProps.value), null, 16))
  ]))
}
}

})